// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }
  .ps__rail-x {
    height: 15px;
    bottom: 0;
  }
  .ps__rail-x,
  .ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    position: absolute;
  }
  .ps__rail-y {
    width: 15px;
    right: 0;
  }
  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }
  .ps--focus > .ps__rail-x,
  .ps--focus > .ps__rail-y,
  .ps--scrolling-x > .ps__rail-x,
  .ps--scrolling-y > .ps__rail-y,
  .ps:hover > .ps__rail-x,
  .ps:hover > .ps__rail-y {
    opacity: 0.6;
  }
  .ps .ps__rail-x.ps--clicking,
  .ps .ps__rail-x:focus,
  .ps .ps__rail-x:hover,
  .ps .ps__rail-y.ps--clicking,
  .ps .ps__rail-y:focus,
  .ps .ps__rail-y:hover {
    background-color: #eee;
    opacity: 0.9;
  }
  .ps__thumb-x {
    transition: background-color 0.2s linear, height 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
    height: 6px;
    bottom: 2px;
  }
  .ps__thumb-x,
  .ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    position: absolute;
    min-height: 5px;
  }
  .ps__thumb-y {
    transition: background-color 0.2s linear, width 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
    width: 6px;
    right: 2px;
  }
  .ps__rail-x.ps--clicking .ps__thumb-x,
  .ps__rail-x:focus > .ps__thumb-x,
  .ps__rail-x:hover > .ps__thumb-x {
    background-color: #999;
    height: 11px;
  }
  .ps__rail-y.ps--clicking .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y,
  .ps__rail-y:hover > .ps__thumb-y {
    background-color: #999;
    width: 11px;
  }
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }
  @media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
    .ps {
      overflow: auto !important;
    }
  }
  .list-dk-scroll-view .ps__thumb-x {
    bottom: 0;
  }
  .list-dk-scroll-view .ps__rail-y {
    left: auto !important;
  }
  .list-dk-scroll-view .ps__rail-x,
  .list-dk-scroll-view .ps__rail-y {
    z-index: 6 !important;
  }
  .list-dk-scroll-view.perfect-list {
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
  .list-dk-scroll-view.perfect-list .scroll-content {
    position: relative;
    display: block;
    width: 100%;
    height: inherit;
    max-height: inherit;
  }
  .list-dk-scroll-view.perfect-list .scroll-content.scroll-always > .ps__rail-x,
  .list-dk-scroll-view.perfect-list .scroll-content.scroll-always > .ps__rail-y {
    opacity: 0.65 !important;
  }
  .list-dk-scroll-view.perfect-list .scroll-content.scroll-wheel-stop {
    overscroll-behavior: contain;
  }
  .list-dk-scroll-view.perfect-list.ps {
    border: 0 !important;
  }
  .list-dk-scroll-view.perfect-list.ps.scroll-always > .ps__rail-x,
  .list-dk-scroll-view.perfect-list.ps.scroll-always > .ps__rail-y {
    opacity: 0.65 !important;
  }
  .list-dk-scroll-view.perfect-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
  }
  .list-dk-scroll-view.perfect-table thead {
    display: block;
  }
  .list-dk-scroll-view.perfect-table thead tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .list-dk-scroll-view.perfect-table tbody {
    display: block;
    position: relative;
    overflow: hidden;
  }
  .list-dk-scroll-view.perfect-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .list-dk-scroll-view.perfect-table tbody.ps {
    border: 0 !important;
  }
  .list-dk-scroll-view.perfect-table tbody.scroll-always > .ps__rail-x,
  .list-dk-scroll-view.perfect-table tbody.scroll-always > .ps__rail-y {
    opacity: 0.65 !important;
  }
  .list-dk-scroll-view.perfect-table tbody.scroll-wheel-stop {
    overscroll-behavior: contain;
  }
  `, "",{"version":3,"sources":["webpack://./src/scrollbar.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,SAAS;EACX;EACA;;IAEE,aAAa;IACb,UAAU;IACV,6DAA6D;IAC7D,qEAAqE;IACrE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;;IAEE,cAAc;IACd,6BAA6B;EAC/B;EACA;;;;;;IAME,YAAY;EACd;EACA;;;;;;IAME,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,iEAAiE;IACjE,yEAAyE;IACzE,WAAW;IACX,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gEAAgE;IAChE,wEAAwE;IACxE,UAAU;IACV,UAAU;EACZ;EACA;;;IAGE,sBAAsB;IACtB,YAAY;EACd;EACA;;;IAGE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE;MACE,yBAAyB;IAC3B;EACF;EACA;IACE;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,SAAS;EACX;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B","sourcesContent":[".ps {\n    overflow: hidden !important;\n    overflow-anchor: none;\n    -ms-overflow-style: none;\n    touch-action: auto;\n    -ms-touch-action: auto;\n  }\n  .ps__rail-x {\n    height: 15px;\n    bottom: 0;\n  }\n  .ps__rail-x,\n  .ps__rail-y {\n    display: none;\n    opacity: 0;\n    transition: background-color 0.2s linear, opacity 0.2s linear;\n    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;\n    position: absolute;\n  }\n  .ps__rail-y {\n    width: 15px;\n    right: 0;\n  }\n  .ps--active-x > .ps__rail-x,\n  .ps--active-y > .ps__rail-y {\n    display: block;\n    background-color: transparent;\n  }\n  .ps--focus > .ps__rail-x,\n  .ps--focus > .ps__rail-y,\n  .ps--scrolling-x > .ps__rail-x,\n  .ps--scrolling-y > .ps__rail-y,\n  .ps:hover > .ps__rail-x,\n  .ps:hover > .ps__rail-y {\n    opacity: 0.6;\n  }\n  .ps .ps__rail-x.ps--clicking,\n  .ps .ps__rail-x:focus,\n  .ps .ps__rail-x:hover,\n  .ps .ps__rail-y.ps--clicking,\n  .ps .ps__rail-y:focus,\n  .ps .ps__rail-y:hover {\n    background-color: #eee;\n    opacity: 0.9;\n  }\n  .ps__thumb-x {\n    transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    height: 6px;\n    bottom: 2px;\n  }\n  .ps__thumb-x,\n  .ps__thumb-y {\n    background-color: #aaa;\n    border-radius: 6px;\n    position: absolute;\n    min-height: 5px;\n  }\n  .ps__thumb-y {\n    transition: background-color 0.2s linear, width 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;\n    width: 6px;\n    right: 2px;\n  }\n  .ps__rail-x.ps--clicking .ps__thumb-x,\n  .ps__rail-x:focus > .ps__thumb-x,\n  .ps__rail-x:hover > .ps__thumb-x {\n    background-color: #999;\n    height: 11px;\n  }\n  .ps__rail-y.ps--clicking .ps__thumb-y,\n  .ps__rail-y:focus > .ps__thumb-y,\n  .ps__rail-y:hover > .ps__thumb-y {\n    background-color: #999;\n    width: 11px;\n  }\n  @supports (-ms-overflow-style: none) {\n    .ps {\n      overflow: auto !important;\n    }\n  }\n  @media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {\n    .ps {\n      overflow: auto !important;\n    }\n  }\n  .list-dk-scroll-view .ps__thumb-x {\n    bottom: 0;\n  }\n  .list-dk-scroll-view .ps__rail-y {\n    left: auto !important;\n  }\n  .list-dk-scroll-view .ps__rail-x,\n  .list-dk-scroll-view .ps__rail-y {\n    z-index: 6 !important;\n  }\n  .list-dk-scroll-view.perfect-list {\n    position: relative;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n  }\n  .list-dk-scroll-view.perfect-list .scroll-content {\n    position: relative;\n    display: block;\n    width: 100%;\n    height: inherit;\n    max-height: inherit;\n  }\n  .list-dk-scroll-view.perfect-list .scroll-content.scroll-always > .ps__rail-x,\n  .list-dk-scroll-view.perfect-list .scroll-content.scroll-always > .ps__rail-y {\n    opacity: 0.65 !important;\n  }\n  .list-dk-scroll-view.perfect-list .scroll-content.scroll-wheel-stop {\n    overscroll-behavior: contain;\n  }\n  .list-dk-scroll-view.perfect-list.ps {\n    border: 0 !important;\n  }\n  .list-dk-scroll-view.perfect-list.ps.scroll-always > .ps__rail-x,\n  .list-dk-scroll-view.perfect-list.ps.scroll-always > .ps__rail-y {\n    opacity: 0.65 !important;\n  }\n  .list-dk-scroll-view.perfect-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n  }\n  .list-dk-scroll-view.perfect-table thead {\n    display: block;\n  }\n  .list-dk-scroll-view.perfect-table thead tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n  .list-dk-scroll-view.perfect-table tbody {\n    display: block;\n    position: relative;\n    overflow: hidden;\n  }\n  .list-dk-scroll-view.perfect-table tbody tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n  .list-dk-scroll-view.perfect-table tbody.ps {\n    border: 0 !important;\n  }\n  .list-dk-scroll-view.perfect-table tbody.scroll-always > .ps__rail-x,\n  .list-dk-scroll-view.perfect-table tbody.scroll-always > .ps__rail-y {\n    opacity: 0.65 !important;\n  }\n  .list-dk-scroll-view.perfect-table tbody.scroll-wheel-stop {\n    overscroll-behavior: contain;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
